import { useState } from 'react';
import { categories } from '../types/category';
import { CreateRecordModal } from './CreateRecordModal';
import { summarizeUrl } from '../lib/api';

export function UrlTab() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [url, setUrl] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [summaryData, setSummaryData] = useState<{ name: string; detail: string } | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedCategory) return;

    setIsLoading(true);
    setError(null);

    try {
      const summary = await summarizeUrl(url);
      setSummaryData(summary);
      setIsModalOpen(true);
    } catch (error) {
      setError(error instanceof Error ? error.message : 'Failed to process URL');
    } finally {
      setIsLoading(false);
    }
  };

  const handleConfirm = (data: { name: string; detail: string }) => {
    // Here you would handle the record creation with URL, category, name, and detail
    console.log('Creating record with:', {
      url,
      categoryId: selectedCategory,
      name: data.name,
      detail: data.detail
    });
    setIsModalOpen(false);
    // Reset form
    setUrl('');
    setSelectedCategory('');
    setError(null);
    setSummaryData(null);
  };

  return (
    <>
      <form onSubmit={handleSubmit} className="space-y-6">
        {error && (
          <div className="bg-red-500/10 text-red-500 p-4 rounded-lg text-sm">
            {error}
          </div>
        )}

        <div>
          <label className="block text-sm font-medium mb-2">Category</label>
          <select
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}
            className="w-full bg-[#383838] rounded-lg px-4 py-2 text-white border-0"
            required
          >
            <option value="">Select a category</option>
            {categories.map((category) => (
              <option key={category.id} value={category.id}>
                {category.title}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium mb-2">URL</label>
          <input
            type="url"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            placeholder="Enter URL"
            className="w-full bg-[#383838] rounded-lg px-4 py-2 text-white"
            required
            disabled={isLoading}
          />
        </div>

        <button
          type="submit"
          disabled={isLoading}
          className="w-full bg-[#1DB954] text-white py-3 rounded-full font-medium hover:bg-[#1ed760] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isLoading ? 'Processing...' : 'Create Record'}
        </button>
      </form>

      <CreateRecordModal
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          setSummaryData(null);
        }}
        onConfirm={handleConfirm}
        categoryId={selectedCategory}
        initialData={summaryData}
        sourceUrl={url}
      />
    </>
  );
} 